import { cn } from '@/lib/utils';

interface DiffViewerProps {
    diff: string;
    className?: string;
}

/**
 * מציג unified diff בצורה צבעונית:
 *   + שורות ירוקות (נוסף)
 *   - שורות אדומות (הוסר)
 *   @@ כחול (header)
 *   --- / +++ אפור (meta)
 */
export function DiffViewer({ diff, className }: DiffViewerProps) {
    if (!diff.trim()) {
        return (
            <p className="text-muted-foreground text-sm italic py-4 text-center" dir="rtl">
                לא נמצאו שינויים בתוכן
            </p>
        );
    }

    const lines = diff.split('\n');

    return (
        <pre
            dir="ltr"
            className={cn(
                'text-xs font-mono overflow-auto rounded-lg border bg-muted/20 py-2 leading-6',
                className
            )}
        >
            {lines.map((line, i) => {
                let cls = 'block px-3 text-foreground';
                if (line.startsWith('+++') || line.startsWith('---')) {
                    cls = 'block px-3 text-muted-foreground';
                } else if (line.startsWith('@@')) {
                    cls = 'block px-3 text-blue-600 dark:text-blue-400 font-semibold bg-blue-50 dark:bg-blue-950/40';
                } else if (line.startsWith('+')) {
                    cls = 'block px-3 border-r-2 border-green-500 bg-green-50 dark:bg-green-950/40 text-green-800 dark:text-green-300';
                } else if (line.startsWith('-')) {
                    cls = 'block px-3 border-r-2 border-red-500 bg-red-50 dark:bg-red-950/40 text-red-800 dark:text-red-300';
                }
                return (
                    <span key={i} className={cls}>
                        {line || '\u00a0'}
                    </span>
                );
            })}
        </pre>
    );
}
